'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDisplayedProducts = exports.toggleAddedModal = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _themeA11y = require('@shopify/theme-a11y');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var postAddItems = function postAddItems(data) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(function (response) {
    return true;
  }).catch(function (error) {
    return false;
  });
};

var toggleAddedModal = exports.toggleAddedModal = function toggleAddedModal(isActive) {
  var modal = document.querySelector('[data-added-modal]');
  var products = modal.querySelectorAll('[data-added-product].active');
  var productsContainer = modal.querySelector('[data-added-products]');
  var copy = modal.querySelector('[data-added-copy]');
  var siteHtml = document.querySelector('[data-site-html]');
  var siteBody = document.querySelector('[data-site-body]');

  if (!modal || !siteHtml || !siteBody || !copy || !productsContainer) return;

  modal.classList.toggle('active', isActive);

  isActive ? (0, _themeA11y.trapFocus)(modal) : (0, _themeA11y.removeTrapFocus)();

  siteHtml.classList.toggle('modal-active', isActive);
  siteBody.classList.toggle('modal-active', isActive);

  copy.classList.toggle('hide', products.length <= 0);
  productsContainer.classList.toggle('hide', products.length <= 0);
};

var updateDisplayedProducts = exports.updateDisplayedProducts = function updateDisplayedProducts(handleArray) {
  document.querySelectorAll('[data-added-product]').forEach(function (productEl) {
    var handle = productEl.getAttribute('data-added-product');

    productEl.classList.toggle('active', handleArray.includes(handle));
  });
};

var addProductToCart = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(productEl, submitBtn) {
    var qtyEl, variantSelect, propertyInputs, quantity, variantId, properties, items, isSuccessful, currentText;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            qtyEl = productEl.querySelector('[data-added-qty-value]');
            variantSelect = productEl.querySelector('[data-added-variant]');
            propertyInputs = productEl.querySelectorAll('input');

            if (!(!qtyEl || !variantSelect)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt('return');

          case 5:
            quantity = qtyEl.getAttribute('data-added-qty-value');
            variantId = variantSelect.value;
            properties = {};


            propertyInputs.forEach(function (input) {
              properties[input.name] = input.value;
            });

            items = {
              "items": [{
                id: variantId,
                quantity: quantity,
                properties: properties
              }]
            };


            submitBtn.disabled = true;
            _context.next = 13;
            return postAddItems(items);

          case 13:
            isSuccessful = _context.sent;

            submitBtn.disabled = false;

            if (isSuccessful) {
              currentText = submitBtn.innerText;

              submitBtn.innerText = 'Added';

              setTimeout(function () {
                submitBtn.innerText = currentText;
              }, 30000);
            }

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function addProductToCart(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var updateQty = function updateQty(delta, productEl) {
  var qty = productEl.querySelector('[data-added-qty-value]');
  if (!qty) return;

  var currentQty = parseInt(qty.getAttribute('data-added-qty-value'), 10) || 1;
  var targetQty = currentQty + delta;

  qty.setAttribute('data-added-qty-value', targetQty < 1 ? 1 : targetQty);
};

var initBybAddedToCart = function initBybAddedToCart() {
  document.querySelectorAll('[data-added-close]').forEach(function (closeTrigger) {
    closeTrigger.addEventListener('click', function (e) {
      if (e.target === e.currentTarget) toggleAddedModal(false);
    });
  });

  document.querySelectorAll('[data-added-product]').forEach(function (productEl) {
    var increaseBtn = productEl.querySelector('[data-added-qty-increase]');
    var decreaseBtn = productEl.querySelector('[data-added-qty-decrease]');
    var submitBtn = productEl.querySelector('[data-added-submit]');

    if (increaseBtn) increaseBtn.addEventListener('click', function () {
      return updateQty(1, productEl);
    });
    if (decreaseBtn) decreaseBtn.addEventListener('click', function () {
      return updateQty(-1, productEl);
    });
    if (submitBtn) submitBtn.addEventListener('click', function () {
      return addProductToCart(productEl, submitBtn);
    });
  });
};

document.addEventListener('DOMContentLoaded', function () {
  initBybAddedToCart();
});

document.addEventListener('shopify:section:load', function () {
  initBybAddedToCart();
});